export const NAMESPACE = 'PATIENT_WHATSAPP_MESSAGES';